<template>
	<div>
		<v-container fluid pt-0 grid-list-xl>
		
			<!-- Sales -->
			<v-layout row wrap>
					<app-card 
						:heading="$t('message.services')"
						colClasses="xl12 lg12 md12 sm12 xs12"
						customClasses="mb-0">
						
				<v-layout row wrap>
			  </v-layout>

						<span id="rptTrans">
							<v-data-table :items="record" v-bind:headers="headersTotals" hide-actions >
								
								<template slot="items" slot-scope="props">
									<td> {{ props.item.UserName }}</td>
									<td>{{ props.item.WorkingDay }}</td>
									<td>{{ props.item.KindWeek }}</td>
                                    <td>{{ props.item.FromTime1 }}</td>
                                    <td>{{ props.item.ToTime1 }}</td>
                                    <td>{{ props.item.FromTime2 }}</td>
                                    <td>{{ props.item.ToTime2 }}</td>
                                    <td>{{ props.item.FlgHoliday }}</td>
                                    <td>{{ props.item.FlgOnline }}</td>
								</template>
								
							</v-data-table>
						</span>
					</app-card>
			</v-layout>
		</v-container>
	</div>
</template>

<script>
// charts component
import Sales from "Components/Reports/MonthGraphStat";
import Invoice from "Components/Widgets/Invoice";
import myHttpApi from "../../api/myHttpApi";
import Datepicker from 'vuejs-datepicker';
import Icon from 'vue-awesome/components/Icon'
import Printd from "printd"
import moment from 'moment'
import jsPDF from 'jspdf';
import 'jspdf-autotable';

export default {
  components: {
		Sales,
		Invoice,
		Datepicker,
		Icon
	},
	props: ['kindrec'],
  data() {
    return {
	  dateMonth: "",
	  record : {},
	  headersTotals: [
        { text: "Naam",sortable: false},
		{ text: "Dag",sortable: false},
        { text: "Soort",sortable: false},
        { text: "Van 1",sortable: false},
        { text: "Tot 1",sortable: false},
        { text: "Van 2",sortable: false},
        { text: "Tot 3",sortable: false},
        { text: "Vakantie",sortable: false},
        { text: "Online",sortable: false}
      ],
    };
	},
	 watch: {
    kindrec (newId, oldId) {
        this.kindrec = newId;
        this.disable = false;
        this.getRemoteData();
    }
  },
   mounted() {
	this.dateMonth =  this.getDate (new Date()); 
	//this.getRemoteData();
	
  },
  methods: {
    getRemoteData() {
			myHttpApi
			
		const searchRec = {Search: this.kindrec, Extra : ''}

		myHttpApi.post('BOUser/GetHours', searchRec)
        .then(response => {
			this.record = response.data;
        })
        .catch(error => {
          console.log(error);
        });
	},
	getDate (rec) {
           return moment(String(rec)).format('YYYY-MM-DD');
  },
	getMonthDt (rec) {
           return moment(String(rec)).format('MMM');
		},
	selDate (dat) {
		 //console.log ("date selected :" + dat);
		 this.dateMonth = dat;
		 this.getRemoteData();
	},
  }
};
</script>
